import React, { useEffect, useState } from "react";
import {
  Button,
  Space,
  Table,
  Modal,
  Form,
  Radio,
  Input,
  message,
  Select,
  Upload, Tag,
} from "antd";
import playroomService from "../../services/playroom.service";
import accountService from "../../services/account.service";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";

export default function PlayroomList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [playrooms, setPlayrooms] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountsWithoutPlayroom, setAccountsWithoutPlayroom] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm(); // Using Antd form handling

  useEffect(() => {
    fetchPlayrooms();
    fetchAccountsWithoutPlayroom();
  }, [pageSize, pageNumber]);

  const fetchPlayrooms = () => {
    playroomService
      .getAllPlayrooms(pageSize, pageNumber)
      .then((result) => {
        if (result.status === 200) {
          console.log("igraonice" + result.data);
          const mappedPlayrooms = result.data.items.map((playroom, index) => ({
            key: index,
            id: playroom.id,
            name: playroom.name,
            location: playroom.location,
            status: playroom.status,
            isPremium: playroom.isPremium
            // account:playroom.account
          }));
          setTotalItems(result.data.totalItems);
          setPlayrooms(mappedPlayrooms);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchAccountsWithoutPlayroom = () => {
    accountService
      .getAllAccountsWithoutPlayroom()
      .then((response) => {
        if (response.status === 200) {
          setAccountsWithoutPlayroom(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      title: "Igraonica",
      dataIndex: "name",
      key: "name",
      className: "text-base"
    },
    {
      title: "Premium",
      dataIndex: "isPremium",
      key: "isPremium",
      className: "text-base",
      render: (isPremium) => renderPremium(isPremium)
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => renderPlayroomStatus(status),
      className: "text-base"
    },
    {
      title: "Akcija",
      key: "link",
      render: (playroom) => renderPlayroom(playroom.id),
      className: "text-base"
    },
  ];

  const renderPlayroomStatus = (status) => {
    if (status === "PLAYROOM_ACTIVE") {
      return <div className="flex justify-center items-center space-x-2"><Tag className="text-base" color={"green"}>AKTIVNA</Tag></div>
    }
    return <div className="flex justify-center items-center space-x-2"><Tag className="text-base" color={"red"}>NEAKTIVNA</Tag></div>
  }

  const renderPremium = (isPremium) => {
    if (isPremium) {
      return <div className="flex justify-center items-center space-x-2"><Tag className="text-base" color={"yellow"}>PREMIUM</Tag></div>
    }
    return <div className="flex justify-center items-center space-x-2"><Tag className="text-base" color={"red"}>NIJE PREMIUM</Tag></div>
  }

  const renderPlayroom = (playroomId) => {
    if (!playroomId) {
      return <span>Igraonica ne postoji.</span>;
    }

    return (
      <div className="flex justify-center items-center space-x-2">
        <Button type="primary" onClick={() => navigate(`/playrooms/${playroomId}`)}>Detalji</Button>
        <Button type="primary" danger onClick={() => handleChangePlayroomStatus(playroomId)}>Promjeni status</Button>
        <Button type="submit" className="bg-green-400 text-white" danger onClick={() => handleChangePremiumStatus(playroomId)}>Premium</Button>
      </div>
    );
  };

  const handleChangePlayroomStatus = (playroomId) => {
    playroomService.changePlayroomStatus(playroomId)
      .then((response) => {
        if (response.status === 200) {
          console.log("Changed status --> " + response.data.status);
          fetchPlayrooms();
        }
      }).catch((err) => {
        console.log(err);
      });
  }

  const handleChangePremiumStatus = (playroomId) => {
    playroomService.changePremiumPlayroomStatus(playroomId)
      .then((response) => {
        if (response.status === 200) {
          fetchPlayrooms();
        }
      }).catch((err) => {
        console.log(err);
      })
  }

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleFileListUpload = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleUploadImages = async (playroomId) => {
    try {
      if (fileList.length > 0) {
        await playroomService.uploadImage(playroomId, fileList);
      }
    } catch (error) {
      message.error("Došlo je do greške pri dodavanju fotografija!");
    }
  };

  const handleCreatePlayroom = async (values) => {
    setLoading(true);

    try {
      console.log("Submitted values:", values);
      const response = await playroomService.createPlayroom(values);
      const createdPlayroom = response.data;
      if (createdPlayroom && createdPlayroom.id) {
        handleUploadImages(createdPlayroom.id);
        handleModalCancel();
        fetchPlayrooms();
        message.success("Uspješno je kreirana nova igraonica.");
        // setTimeout(() => {
        //   navigate(`/playrooms/${createdPlayroom.id}`);
        // }, 1000);
      } else {
        message.error("Greška pri kreiranju igraonice. Nedostaje ID.");
      }
    } catch (error) {
      message.error("Došlo je do greške pri kreiranju nove igraonice!");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setPageNumber(pagination.current);
    setPageSize(pagination.pageSize);
  };

  return (
    <div className="container mx-auto px-6 py-6">
      {" "}
      <div className="mb-4">
        <Space direction="vertical">
          <Button
            type="primary"
            size="large"
            style={{ paddingLeft: "10px" }}
            onClick={showModal}
          >
            <span
              style={{
                fontSize: "24px",
                marginBottom: "6px",
              }}
            >
              +
            </span>
            Dodaj igraonicu
          </Button>
          <div className="container mx-auto px-4 py-4">
            <div className="w-full sm:w-3/4 lg:w-1/2 mx-auto">
              <Modal
                title="Nova igraonica"
                open={isModalOpen}
                onCancel={handleModalCancel}
                footer={[
                  <Button key="cancel" onClick={handleModalCancel}>
                    Zatvori
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={() => form.submit()}
                  >
                    Dodaj
                  </Button>,
                ]}
                style={{ width: "50%" }}
                centered
              >
                <Form
                  form={form}
                  onFinish={handleCreatePlayroom}
                  labelCol={{ span: 5 }}
                  wrapperCol={{ span: 19 }}
                  labelAlign="left"
                  requiredMark={false}
                  validateMessages={{
                    required: "Potrebno je popuniti sva polja",
                  }}
                >
                  <Form.Item
                    name="name"
                    label="Naziv"
                    rules={[
                      { required: true, message: "Unesite naziv igraonice" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="location"
                    label="Lokacija"
                    rules={[
                      { required: true, message: "Unesite lokaciju igraonice" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="contactInfo"
                    label="Kontakt"
                    rules={[
                      { required: true, message: "Unesite kontakt telefon" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="maxGuestsNumber"
                    label="Broj gostiju"
                    rules={[
                      {
                        required: true,
                        message: "Unesite maksimalan broj gostiju",
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                  <Form.Item
                    name="maxNumberOfChildren"
                    label="Broj djece"
                    rules={[
                      {
                        required: true,
                        message: "Unesite maksimalan broj djece",
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                  <Form.Item
                    name="companyNumber"
                    label="JIB"
                    rules={[
                      {
                        required: true,
                        message: "Unesite JIB",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="bankAccountNumber"
                    label="Bankovni racun"
                    rules={[
                      {
                        required: true,
                        message: "Unesite broj bankovnog racuna",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="description"
                    label="Opis igraonice"
                    rules={[
                      {
                        required: true,
                        message: "Unesite opis igraonice",
                      },
                    ]}
                  >

                    <TextArea />
                  </Form.Item>

                  <Form.Item name="hasFood" label="Hrana">
                    <Radio.Group defaultValue="ne" buttonStyle="solid">
                      <Radio.Button value={true}>Da</Radio.Button>
                      <Radio.Button value={false}>Ne</Radio.Button>
                    </Radio.Group>

                  </Form.Item>
                  <Form.Item
                    name="accountId"
                    label="Vlasnik"
                    rules={[
                      { required: true, message: "Izaberite vlasnika igraonice" },
                    ]}
                  >

                    <Select
                      showSearch
                      style={{
                        width: 200,
                      }}
                      placeholder="Izaberi vlasnika"
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={accountsWithoutPlayroom.map((account) => ({
                        value: account.id,
                        label: `${account.firstName} ${account.lastName}`,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item label="Slika">
                    <Upload
                      multiple
                      beforeUpload={() => false}
                      onChange={handleFileListUpload}
                      fileList={fileList}
                    >
                      <Button icon={<UploadOutlined />}>Dodaj sliku</Button>
                    </Upload>
                  </Form.Item>
                </Form>
              </Modal>
            </div>
          </div>
        </Space>
      </div>

      <div className="bg-white p-4 shadow rounded-lg">
        {" "}
        <Table
          columns={columns}
          dataSource={playrooms}
          pagination={{
            current: pageNumber,
            pageSize: pageSize,
            showSizeChanger: false,
            total: totalItems,
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
}
